import './instagram_card_carrousel.css';
import { useEffect, useState } from 'react';


const URL = process.env.REACT_APP_META_API_ACCESS;

async function Fetch() {
    const resp = await fetch(URL);

    if (resp.status === 200) {
        const obj = await resp.json();
        return obj;
    }
}

export default function InstagramCardCarrousel() {

  const [dados, setDados] = useState([]);

  useEffect(() => {
    async function carregar() {
      const result = await Fetch();
      if (result && result.data) {
        setDados(result.data);
      }
    }
    carregar();
  }, []);
  
  return (
    <div className="container__carrousel">
    {dados.length === 0
      ? Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className="carrousel__card loading-card">
            <div className="skeleton skeleton-header"></div>
            <div className="skeleton skeleton-image"></div>
            <div className="skeleton skeleton-text"></div>
          </div>
        ))
      : dados.map((post, index) => (
          <div key={index} className="carrousel__card">
            <div className="card__data">
              {new Intl.DateTimeFormat('pt-BR').format(new Date(post.timestamp))}
              <a
                href={post.permalink}
                target="_blank"
                rel="noopener noreferrer"
                className="data__social-link"
              >
                <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        className="data__icon--instagram"
                    >
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                    </svg>
              </a>
            </div>
            <div className="card__media">
              <img src={post.media_url} alt="imagem" className="card__imagem" />
              <a
                href={post.permalink}
                target="_blank"
                rel="noopener noreferrer"
                className="instagram-icon__container"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  className="instagram-icon"
                >
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07..." />
                </svg>
              </a>
            </div>
            <div className="card__texto">
              <p className="texto__texto-post">{post.caption}...</p>
            </div>
          </div>
        ))}
    </div>
  );
};